"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledTableHeader = exports.StyledGhostText = exports.StyledGhostIcon = exports.StyledButtonContainer = void 0;
var _Icon = _interopRequireDefault(require("../Icon"));
var _Typography = _interopRequireDefault(require("../Typography/Typography"));
var _StyledUpload = require("../Upload/StyledUpload");
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledTitle = exports.StyledTitle = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bx4cic-0"
})(["", ""], function (props) {
  return props.$onlyChild && (0, _ykbStyledComponents.css)(["width:100%;"]);
});
var StyledButtonContainer = exports.StyledButtonContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bx4cic-1"
})([".ykb-ui-select-container{display:inline-block;width:auto;}"]);
var StyledTableHeader = exports.StyledTableHeader = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bx4cic-2"
})(["", ";", "{color:", ";font-weight:500;float:left;line-height:", ";}", "{float:right;text-align:right;line-height:", "px;&::first-line{line-height:", ";}a{margin:0;&:hover,&:active{text-decoration:none;}}", ";", "{display:inline;", "{display:inline;.ykb-ui-upload{", ";}}}label.ykb-ui-checkbox{display:inline-flex;align-items:center;vertical-align:middle;}}"], function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
}, StyledTitle, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.button.size.small.height;
}, StyledButtonContainer, function (props) {
  return parseInt(props.theme.button.size.small.height) + 5;
}, function (props) {
  return props.theme.button.size.small.height;
}, function () {
  return StyledTableHeaderButtonMixin;
}, _StyledUpload.StyledUploadButtonContainer, _StyledUpload.StyledUpload, function () {
  return StyledTableHeaderButtonMixin;
});
var StyledTableHeaderButtonMixin = function StyledTableHeaderButtonMixin() {
  return (0, _ykbStyledComponents.css)(["> button > .text{margin-left:", " !important;}> button{margin-left:", ";margin-right:0 !important;}"], function (props) {
    return props.theme.tableHeader.button.text.marginLeft;
  }, function (props) {
    return props.theme.button.marginRight;
  });
};
var StyledGhostIcon = exports.StyledGhostIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bx4cic-3"
})(["font-size:24px;"]);
var StyledGhostText = exports.StyledGhostText = (0, _ykbStyledComponents.default)(_Typography.default.Text).withConfig({
  componentId: "ykb-ui__sc-1bx4cic-4"
})(["margin-left:8px;line-height:24px;"]);